import { render, staticRenderFns } from "./smallAdvertisement.vue?vue&type=template&id=347d45d5&scoped=true"
import script from "./smallAdvertisement.vue?vue&type=script&lang=js"
export * from "./smallAdvertisement.vue?vue&type=script&lang=js"
import style0 from "./smallAdvertisement.vue?vue&type=style&index=0&id=347d45d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347d45d5",
  null
  
)

export default component.exports